import axios from '../helpers/axios'
import { logError } from '../services';
import {
  IResponse,
  ISupervisor,
  ISupervisorActiveNeighborhood,
  ISupervisorCreate,
  ISupervisorDetail,
  ISupervisorUpdate,

} from '../models';
import qs from 'querystring';

export const getSupervisors = async (filters?: {
  page?: number;
  perPage?: number | string;
  sortBy?: string;
  sortDirection?: string;
  searchTerm?: string;
  territoryId?: string | number;
  neighborhoodId?: string | number;
}): Promise<IResponse<ISupervisor[]>> => {
  try {
    const { data } = await axios.get(`/api/supervisors`, {
      params: filters,
      paramsSerializer: params => qs.stringify(params)
    });
    return data;
  } catch (error: any) {
    logError(error, 'getSupervisors failed');
    return Promise.reject(error.response.data);
  }
};

export const createSupervisor = async (payload: ISupervisorCreate): Promise<number> => {
  try {
    const { data } = await axios.post(`/api/supervisors`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'createSupervisor failed');
    return Promise.reject(error.response.data);
  }
};

export const getSupervisorDetail = async (
  supervisorId: string | number
): Promise<ISupervisorDetail> => {
  try {
    const { data } = await axios.get(`/api/supervisors/${supervisorId}`);
    return data;
  } catch (error: any) {
    logError(error, 'getSupervisorDetail failed');
    return Promise.reject(error.response.data);
  }
};

export const updateSupervisor = async (
  supervisorId: string | number,
  payload: ISupervisorUpdate
): Promise<any> => {
  try {
    const { data } = await axios.put(`/api/supervisors/${supervisorId}`, payload);
    return data;
  } catch (error: any) {
    logError(error, 'updateSupervisor failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteSupervisor = async (supervisorId: string | number) => {
  try {
    const { data } = await axios.delete(`/api/supervisors/${supervisorId}`);
    return data;
  } catch (error: any) {
    logError(error, 'updateSupervisor failed');
    return Promise.reject(error.response.data);
  }
};

export const getSupervisorAvailableNeighborhoods = async (
  supervisorId: string | number
): Promise<ISupervisorActiveNeighborhood[]> => {
  try {
    const { data } = await axios.get(
      `/api/supervisors/${supervisorId}/available-neighborhoods`
    );
    return data;
  } catch (error: any) {
    logError(error, 'getSupervisorAvailableNeighborhoods failed');
    return Promise.reject(error.response.data);
  }
};

export const createSupervisorNeighborhood = async (
  supervisorId: string | number,
  neighborhoodId?: string | number
): Promise<any> => {
  try {
    const { data } = await axios.post(
      `/api/supervisors/${supervisorId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'createSupervisorNeighborhood failed');
    return Promise.reject(error.response.data);
  }
};

export const deleteSupervisorNeighborhood = async (
  supervisorId: string | number,
  neighborhoodId: string | number
): Promise<any> => {
  try {
    const { data } = await axios.delete(
      `/api/supervisors/${supervisorId}/neighborhoods/${neighborhoodId}`
    );
    return data;
  } catch (error: any) {
    logError(error, 'deleteSupervisorNeighborhood failed');
    return Promise.reject(error.response.data);
  }
};